import type { Connection } from "@solana/web3.js";

export const isCallOptionClaimed = async (connection: Connection, claimsMaskPubkey: string, claimIndex: number) => {
  //the bool value of if a option has been exercised (claimed) is stored as a bit on the
  //claimsMask account.  The index represents the bit number in a pure left to right fashion
  //thus 0 is the MSB of the first byte, and 7 is the LSB of the first byte
  //instead of pulling all 31k bytes of claimsMask down, we just pull the byte that contains the bit
  //that we are interested in. Note the "8+" below represents the anchor account discriminator
  const byteOffset = 8 + Math.floor(claimIndex / 8);
  //grab a single byte from the claim mask account's data
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const res = await connection._rpcRequest("getAccountInfo", [
    claimsMaskPubkey,
    {
      encoding: "base64",
      commitment: "processed",
      dataSlice: { offset: byteOffset, length: 1 },
    },
  ]);
  //note, no error handling for acct not found - blindly going after data - which should be exactly 1 byte
  const buf = Buffer.from(res.result.value.data[0], "base64");
  //now we create a mask for the bit of this byte we are going to check, converting from 0=LSB to 0=MSB (hence 7 - X)
  //0 becomes 128 (the MSB or leftmost bit), 7 becomes 1 (the LSB or rightmost bit)
  const byteMask = 1 << (7 - (claimIndex % 8));
  //check the interesting bit of the byte
  return (buf[0] & byteMask) > 0;
};
